__turbopack_context__.v({
  "bar": "InputRange-module__GTF_XG__bar",
  "label": "InputRange-module__GTF_XG__label",
  "mildPain": "InputRange-module__GTF_XG__mildPain",
  "moderatePain": "InputRange-module__GTF_XG__moderatePain",
  "noPain": "InputRange-module__GTF_XG__noPain",
  "point": "InputRange-module__GTF_XG__point",
  "points": "InputRange-module__GTF_XG__points",
  "progress": "InputRange-module__GTF_XG__progress",
  "severePain": "InputRange-module__GTF_XG__severePain",
  "thumb": "InputRange-module__GTF_XG__thumb",
  "tooltip": "InputRange-module__GTF_XG__tooltip",
  "tooltipLabel": "InputRange-module__GTF_XG__tooltipLabel",
  "track": "InputRange-module__GTF_XG__track",
  "verySeverePain": "InputRange-module__GTF_XG__verySeverePain",
  "worstPain": "InputRange-module__GTF_XG__worstPain",
});
